import './App.css';
import { DashboardProvider } from './context/DashboardContext';
import { useAuth } from './context/AuthContext';
import Login from './components/Login';
import Topbar from './components/Topbar';
import Sidebar from './components/Sidebar';
import KpiCards from './components/KpiCards';
import Charts from './components/Charts';

const s = {
  root: { display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden', background: '#f0f2f5' },
  body: { display: 'flex', flex: 1, minHeight: 0 },
  main: { flex: 1, minHeight: 0, overflowY: 'auto', padding: 20, display: 'flex', flexDirection: 'column', gap: 16 },
};

export default function App() {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) return <Login />;

  return (
    <DashboardProvider>
      <div style={s.root}>
        <Topbar />
        <div style={s.body}>
          <Sidebar />
          <main style={s.main}>
            <KpiCards />
            <Charts />
          </main>
        </div>
      </div>
    </DashboardProvider>
  );
}
